/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

export interface SetZoomActionArgs {
  zoomLevel: number;
}

export interface SetZoomResultData {
}

export interface SetZoomActionStateData {
}

function createBaseSetZoomActionArgs(): SetZoomActionArgs {
  return { zoomLevel: 0 };
}

export const SetZoomActionArgs = {
  encode(message: SetZoomActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.zoomLevel !== 0) {
      writer.uint32(13).float(message.zoomLevel);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetZoomActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetZoomActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.zoomLevel = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetZoomActionArgs {
    return { zoomLevel: isSet(object.zoomLevel) ? globalThis.Number(object.zoomLevel) : 0 };
  },

  toJSON(message: SetZoomActionArgs): unknown {
    const obj: any = {};
    if (message.zoomLevel !== 0) {
      obj.zoomLevel = message.zoomLevel;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetZoomActionArgs>, I>>(base?: I): SetZoomActionArgs {
    return SetZoomActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetZoomActionArgs>, I>>(object: I): SetZoomActionArgs {
    const message = createBaseSetZoomActionArgs();
    message.zoomLevel = object.zoomLevel ?? 0;
    return message;
  },
};

function createBaseSetZoomResultData(): SetZoomResultData {
  return {};
}

export const SetZoomResultData = {
  encode(_: SetZoomResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetZoomResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetZoomResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetZoomResultData {
    return {};
  },

  toJSON(_: SetZoomResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetZoomResultData>, I>>(base?: I): SetZoomResultData {
    return SetZoomResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetZoomResultData>, I>>(_: I): SetZoomResultData {
    const message = createBaseSetZoomResultData();
    return message;
  },
};

function createBaseSetZoomActionStateData(): SetZoomActionStateData {
  return {};
}

export const SetZoomActionStateData = {
  encode(_: SetZoomActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetZoomActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetZoomActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetZoomActionStateData {
    return {};
  },

  toJSON(_: SetZoomActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetZoomActionStateData>, I>>(base?: I): SetZoomActionStateData {
    return SetZoomActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetZoomActionStateData>, I>>(_: I): SetZoomActionStateData {
    const message = createBaseSetZoomActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
